import { createGlobalStyle } from "styled-components";
import { colors } from "./variables";

const GlobalStyles = createGlobalStyle`

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: none;
    ::-moz-selection {
    background: ${colors.primary};
    color: ${colors.white};
    }
    ::-webkit-selection {
    background: ${colors.primary};
    color: ${colors.white};
    }
    ::selection {
    background: ${colors.primary};
    color: ${colors.white};
    }
}

button {
    cursor: pointer;
    color: ${colors.white};
    font-size: 1.5rem;
    text-transform: uppercase;
    padding: 1rem 1.5rem;
    border: 2px solid ${colors.primary};
    background: ${colors.primary};
    transition: all .3s;
    &:hover {
        background: transparent;
        border-color: ${colors.white};
    }
}

h1 {
    font-size: 4rem;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    padding: 2rem;
    line-height: 1.2;
}

h2  {
    font-size: 2rem;
    text-transform: uppercase;
    line-height: 1.2;
    text-align: center;
    }

h3 {
    color: ${colors.white};
    font-weight: 500;
    line-height: 1.2;
    text-align: center;
}

h4 {
    color: ${colors.white};
    font-weight: 500;
    line-height: 1.2;
}

p {
    color: ${colors.dark};
    line-height: 1.7;
    font-weight: 300;
    font-size: 1.1rem;
    text-align: justify;
    @media all and (max-width: 1366px) {
    font-size: 1rem;
}
}

a {
    color: ${colors.white};
    text-decoration: none;
    &:hover {
        color: ${colors.primary};
    }
}
`;

export default GlobalStyles;
